export default "__VITE_ASSET__CcWi1SXQ__"